export const createMultipleMutations = (types, fn) => {
  const res = {};
  types.forEach((type) => {
    res[type] = fn;
  });

  return res;
};

export default createMultipleMutations;
